module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'CustomerList'
      }
    }
  }, [_vm._v("Klienci")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'CustomerCreate'
      }
    }
  }, [_c('span', [_vm._v("Dodaj klienta")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.created) ? _c('div', {
    staticClass: "alert alert-success",
    attrs: {
      "role": "status"
    }
  }, [_vm._v("Klient " + _vm._s(_vm.created.fullName) + " został dodany.")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.deletedItem) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.deletedItem['@id']) + " deleted.")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', {
    staticClass: "table-search__form"
  }, [_c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.name),
      callback: function($$v) {
        _vm.$set(_vm.filter, "name", $$v)
      },
      expression: "filter.name"
    }
  }), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.nip),
      callback: function($$v) {
        _vm.$set(_vm.filter, "nip", $$v)
      },
      expression: "filter.nip"
    }
  }), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
    staticClass: "form-control input-search",
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.filter.regon),
      callback: function($$v) {
        _vm.$set(_vm.filter, "regon", $$v)
      },
      expression: "filter.regon"
    }
  }), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "search"
    }
  })], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "no-wrap"
  }, [_c('my-button', {
    attrs: {
      "variant": "info",
      "action": _vm.getItems
    }
  }), _vm._v(" "), _c('my-button', {
    attrs: {
      "icon": "back",
      "variant": "primary",
      "action": _vm.resetFilter
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('name'),
    on: {
      "click": function($event) {
        return _vm.setOrder('name')
      }
    }
  }, [_vm._v("Nazwa firmy")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('nip'),
    on: {
      "click": function($event) {
        return _vm.setOrder('nip')
      }
    }
  }, [_vm._v("NIP")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('regon'),
    on: {
      "click": function($event) {
        return _vm.setOrder('regon')
      }
    }
  }, [_vm._v("REGON")]), _vm._v(" "), _c('th', {
    staticClass: "sorting",
    class: _vm.getOrder('commission'),
    on: {
      "click": function($event) {
        return _vm.setOrder('commission')
      }
    }
  }, [_vm._v("\n                            Prowizja\n                        ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'CustomerShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['name']) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'CustomerShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['nip']) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'CustomerShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(item['regon']) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'CustomerShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("percentage")(item['commission'])) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'CustomerUpdate',
          params: {
            id: item.id
          }
        },
        "title": "Edytuj"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1), _vm._v(" "), _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'AgreementCreate',
          query: {
            customer: item.id
          }
        },
        "title": "Dodaj umowę"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "agreement_small"
      }
    })], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cf5dc1d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/List.vue
// module id = 782
// module chunks = 0